<template>
    <el-dialog
        title="取消订单"
        :visible.sync="cancelDialogVisible"
        :close-on-click-modal="false"
        width="1000px">
        <div class="logisticsDialog">
            <el-form ref="logisticsForm" :rules="cancelRules" class="demo-ruleForm">
                <el-form-item class="addressList">
                    <el-select v-model="cancelUuid" placeholder="取消原因">
                        <el-option v-for="(item,index) in cancelList" :key="index"
                                   :label="item.name"
                                   :value="item.uuid">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="submitButtonGroup">
                    <el-button type="primary" @click="cancelSubmit">确定</el-button>
                    <el-button @click="cancelDialogVisible = false">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </el-dialog>
</template>

<script>
    import { getDictionaryItem,updateOrderShopBaseInfo, } from '../../../utils/interface';
    export default {
        name: "cancelOrder",
        data(){
            return{
                // 取消订单
                cancelDialogVisible:false,
                orderBaseInfo:{},
                cancelList:[],
                cancelUuid:"",
                cancelRules: {
                    cancelUuid:[
                        {required: true, message: '请选择取消原因', trigger: 'change'}
                    ]
                },
            }
        },
        methods: {
            init(item){
                this.orderBaseInfo = item;
                getDictionaryItem({groupCode:"shop_cancel_reason"}).then((res)=>{
                    this.cancelList = res;
                    this.cancelDialogVisible = true;
                });
            },
            // 取消订单
            cancelSubmit(){
                if(this.cancelUuid==""){
                    this.$message.error('请选择取消原因！');
                    return false;
                }
                this.orderBaseInfo.cancelOrderUuid = this.cancelUuid;
                this.orderBaseInfo.orderStatus = "UN_CANCEL";
                updateOrderShopBaseInfo(this.orderBaseInfo).then((res)=>{
                    if(res.success){
                        this.$message.success('订单取消成功！');
                        this.cancelUuid = "";
                        this.cancelDialogVisible = false;
                        this.$emit('cancelOrderSuccess');
                    }
                });
            },
        }
    }
</script>

<style scoped lang="less">
    .addressDialog{
        /deep/.el-dialog__header{
            border-bottom: 1px solid #ddd;
        }
        /deep/.el-dialog__body{
            padding: 0;
        }
        .submitButtonGroup{
            text-align: right;
            margin-bottom: 0;
            border-top: 1px solid #ddd;
            padding: 10px 30px;
        }
    }
    .addressList{
        padding: 24px 30px 20px;
        display: flex;
        flex-wrap: wrap;
        .addressItem{
            padding: 14px 22px;
            margin-bottom: 24px;
            margin-right: 30px;
            position: relative;
            width: 270px;
            border-radius: 8px;
            border: 2px dashed #E3E3E3;
            font-size: 14px;
            .addressBorder{
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
            }
            &.active{
                border: 2px dashed #fff;
            }
            &:nth-of-type(4n){
                margin-right: 0;
            }
            .checkBox{
                position: absolute;
                right: 22px;
                top: 14px;
            }
            .name{
                color: #000;
            }
            .tel{
                color: rgba(51, 51, 51, 0.85);
                padding: 6px 0;
            }
            .address{
                color: rgba(51, 51, 51, 0.85);
                line-height: 22px;
            }
        }
        .addItem{
            text-align: center;
            cursor: pointer;
            color: #666;
            &:hover{
                border: 2px dashed #1890FF;
            }
            .icon{
                font-size: 30px;
            }
            .addName{
                font-size: 14px;
                padding-top: 5px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/transaction/orderManagement/cancelOrderShop.vue